// IMPORT PACKAGE REFERENCES

import { createStore, applyMiddleware } from 'redux';

// IMPORT MIDDLEWARE

import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native

// IMPORT REDUCERS

import { AppReducer } from '../Reducers/AppReducer';

const persistConfig = {
    key: 'root',
    storage,
    // Only persist the small auth slice. Pharmacies/devices/reports are
    // re-fetched from Firebase on load and would blow the localStorage quota.
    whitelist: ['userReducer'],
  }
  
  const persistedReducer = persistReducer(persistConfig, AppReducer)


// CONFIGURE STORE

// export const createAppStore = () => {
//     return createStore(AppReducer, applyMiddleware(thunk, promiseMiddleware()));
// };

export const createAppStore = () => {
    let store = createStore(persistedReducer, applyMiddleware(thunk, promiseMiddleware))
    let persistor = persistStore(store)
    return { store, persistor }
};

// export default () => {
//     let store = createStore(persistedReducer, applyMiddleware(thunk, promiseMiddleware()))
//     let persistor = persistStore(store)
//     return { store, persistor }
// }